/**
 * Frozen by the 2026-08-17 owner billing ruling.
 * Backend #517 is the successor and should replace this module with its catalog.
 */
export const PLAN_TIER_MAPPING_VERSION = "2026-08-17";

const PLAN_TIER_BY_ID = Object.freeze({
  professional: "tier1",
  organization: "tier2",
  enterprise: "tier3",
});

const SUBSCRIPTION_TIERS = new Set(Object.values(PLAN_TIER_BY_ID));

export const resolvePlanTier = (planId) => {
  if (!Object.prototype.hasOwnProperty.call(PLAN_TIER_BY_ID, planId)) {
    throw new Error(`Unknown plan id: ${String(planId)}`);
  }

  return PLAN_TIER_BY_ID[planId];
};

export const isSubscriptionTier = (tierId) =>
  SUBSCRIPTION_TIERS.has(tierId);
